import { useLayoutEffect, useRef } from 'react';
import { registerModalHistory } from 'utils/modalHistory';

export const useModalHistory = (visible: boolean, onHide?: () => unknown) => {
	const onHideRef = useRef(onHide);
	onHideRef.current = onHide;
	const canClose = Boolean(onHide);
	const registration = useRef<(() => void) | undefined>(undefined);
	const generation = useRef({ version: 0 });
	useLayoutEffect(() => {
		const lifecycle = generation.current;
		lifecycle.version += 1;
		const { version } = lifecycle;
		const release = () => {
			registration.current?.();
			registration.current = undefined;
		};
		if (!visible || !canClose) {
			release();
			return undefined;
		}
		registration.current ??= registerModalHistory(() => onHideRef.current?.());
		return () => {
			// React StrictMode can replay setup immediately; retain the same history entry.
			queueMicrotask(() => {
				if (lifecycle.version === version) release();
			});
		};
	}, [visible, canClose]);
};
